import store from "@/store"
import { initGlobalState } from "qiankun"
/**
 * @name 导入注册并启动微应用函数
 */

/**
 * @name 启动qiankun应用间通信机制
 * @param {Function} initGlobalState 官方通信函数
 * @description 注意：主应用是从qiankun中导出的initGlobalState方法，
 * @description 注意：子应用是附加在props上的onGlobalStateChange, setGlobalState方法（只用主应用注册了通信才会有）
 */
const appStore = () => {
  /**
   * @name 初始化数据内容
   */
  return initGlobalState({
    token: '',
    appsRefresh: false,
    init: window
  })
}

export default appStore
